
const COOKIE_NAMES = ['accessToken', 'access_token'];

export const getAccessTokenFromCookie = () => {
  if (typeof document === 'undefined') return null;
  const m = document.cookie.match(new RegExp('(?:^|;\\s*)(?:' + COOKIE_NAMES.join('|') + ')=([^;]+)', 'i'));
  return m ? decodeURIComponent(m[1]) : null;
};

export const setAccessTokenCookie = (token, opts = {}) => {
  if (typeof document === 'undefined') return;
  const { days = 30, path = '/', secure = true, sameSite = 'Lax' } = opts;
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const cookieVal = encodeURIComponent(token);
  document.cookie = `accessToken=${cookieVal}; expires=${expires}; path=${path}; SameSite=${sameSite}${secure ? '; Secure' : ''}`;
  try { localStorage.setItem('accessToken', token); } catch (e) { /* ignore */ }
};

export const removeAccessTokenCookie = () => {
  if (typeof document !== 'undefined') {
    document.cookie = `accessToken=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  }
  try { localStorage.removeItem('accessToken'); } catch (e) { /* ignore */ }
};

export const getAccessToken = () => {
  // prefer cookie, fallback to localStorage
  const c = getAccessTokenFromCookie();
  if (c) return c;
  try {
    return localStorage.getItem('accessToken') || null;
  } catch (e) {
    return null;
  }
};

export const saveAccessToken = (token, opts = {}) => {
  if (!token) return;
  setAccessTokenCookie(token, opts);
};

export const clearAccessToken = () => {
  removeAccessTokenCookie();
};

// convenient header builder
export const getAuthHeaders = (token) => {
  const t = token || getAccessToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

/**
 * Optional: validate / login by access token against your API.
 * Provide `validateEndpoint` if your backend expects a different path.
 * Returns parsed JSON response on success.
 */
export const loginWithAccessToken = async (token, validateEndpoint = `${process.env.REACT_APP_API_BASE_URL}/auth/validate-token`) => {
  if (!token) throw new Error('No token provided');
  const res = await fetch(validateEndpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({}),
  });
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(`Token validation failed: ${res.status} ${txt}`);
  }
  const data = await res.json();
  saveAccessToken(token);
  return data;
};

//jb already login ho gya h to token expire hua ya nhi hua ye check krne k liye
export const parseJwt = (token) => {
  if (!token) return null;
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    // base64 decode
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decodeURIComponent(escape(json)));
  } catch {
    return null;
  }
};

export const isJwtExpired = (token, leewaySeconds = 10) => {
  const payload = parseJwt(token);
  if (!payload || !payload.exp) return true;
  const now = Math.floor(Date.now() / 1000);
  return now >= (Number(payload.exp) - Number(leewaySeconds));
};

// schedule a logout callback to run when token expires; returns timeout id
export const scheduleLogoutOnExpiry = (token, onExpire) => {
  const payload = parseJwt(token);
  if (!payload || !payload.exp || typeof onExpire !== 'function') return null;
  const ms = (Number(payload.exp) * 1000) - Date.now();
  if (ms <= 0) {
    onExpire();
    return null;
  }
  return setTimeout(() => {
    try { onExpire(); } catch (e) { /* ignore */ }
  }, ms + 500);
};